// Modifica indirizzo di spedizione
if ($('#order-history').length) {

  let numeroweb;

  $('body').on('click', '.button-mod-address', function () {

    // prendo il numero di ordine
    numeroweb = $(this).data('ordernum');

    // Pulisco la form
    $('#frm_addressSped')[0].reset();

    // Mostro la form per inserire l'indirizzo di spedizione e nascondo il
    // messaggio di conferma modifica indirizzo
    // $('#popup-spedizione .body-card').removeClass('hidden');
    // $('#popup-spedizione #success-mod-message').addClass('hidden');

    // Apro la popup per inserire l'indirizzo
    // openPopup($('#popup-spedizione'), $overlay);

  });


  $('body').on('click', '#confirmSpedAddress', function () {

    const formNome = $('#Clienti_sedi_nome').val();
    const formCognome = $('#Clienti_sedi_cognome').val();
    const formIndirizzo = $('#Clienti_sedi_indirizzo').val();
    const formCivico = $('#Clienti_sedi_numcivico').val();
    const formCap = $('#Clienti_sedi_cap').val();
    const formCitta = $('#Clienti_sedi_citta').val();
    const formNazione = $('#Nazioni_ID_spedizione option:selected').text();
    const formProvincia = $('#Province_ID_spedizione option:selected').text();

    const formClientiNome = $('#Clienti_nome_sped').val();
    const formClientiCognome = $('#Clienti_cognome_sped').val();
    const formClientiEmail = $('#Clienti_email_sped').val();

    const formordine = numeroweb;

    $.ajax({
      type: 'POST',
      url: '../email/email-modify-shipping-address.php',
      data: {
        Clienti_sedi_nome: formNome,
        Clienti_sedi_cognome: formCognome,
        Clienti_sedi_indirizzo: formIndirizzo,
        Clienti_sedi_numcivico: formCivico,
        Clienti_sedi_cap: formCap,
        Clienti_sedi_citta: formCitta,
        Nazioni_ID_spedizione: formNazione,
        Province_ID_spedizione: formProvincia,
        Clienti_sedi_ordine: formordine,
        Clienti_nome: formClientiNome,
        Clienti_cognome: formClientiCognome,
        Clienti_email: formClientiEmail
      },
      success: function (data) {
        if (data === 'ok') {
          $('#spedizione-main-form').addClass('hidden');
          $('#success-mod-message').removeClass('hidden');
        } else {
          console.log(data);
        }
      }
    });

  });

}
